import { TreeApi, RootPersonResponse, TreePeopleResponse } from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped tree API with standardized error handling
 */
class WrappedTreeApi {
  /**
   * Get the root person for a family tree
   */
  async getRootPerson(familyId: string): Promise<ApiResult<RootPersonResponse>> {
    return withApiSetup(
      (config) => new TreeApi(config),
      getApiConfiguration,
      (api) => api.getRootPerson(familyId)
    );
  }

  /**
   * Get ancestors for a person
   */
  async getAncestors(
    familyId: string,
    familyMemberId: string,
    generations?: number,
    includeSpouses?: boolean
  ): Promise<ApiResult<TreePeopleResponse>> {
    return withApiSetup(
      (config) => new TreeApi(config),
      getApiConfiguration,
      (api) => api.getAncestors(familyId, familyMemberId, generations, includeSpouses)
    );
  }

  /**
   * Get root generation for a family tree
   */
  async getRootGeneration(
    familyId: string,
    familyMemberId: string,
    includeSpouses?: boolean
  ): Promise<ApiResult<TreePeopleResponse>> {
    return withApiSetup(
      (config) => new TreeApi(config),
      getApiConfiguration,
      (api) => api.getRootGeneration(familyId, familyMemberId, includeSpouses)
    );
  }

  /**
   * Get descendants for a person
   */
  async getDescendants(
    familyId: string,
    familyMemberId: string,
    generations?: number,
    includeSpouses?: boolean
  ): Promise<ApiResult<TreePeopleResponse>> {
    return withApiSetup(
      (config) => new TreeApi(config),
      getApiConfiguration,
      (api) => api.getDescendants(familyId, familyMemberId, generations, includeSpouses)
    );
  }
}

/**
 * Wrapped tree API instance with standardized error handling
 */
export const treeApi = new WrappedTreeApi();

export default treeApi;
